#@export GliveBooking.Views.Picker

class GliveBooking.Views.Picker extends BookingV2.Views.Picker

  className: -> "picker glive-picker #{@collapsedClassName} #{@styleClassName}"

  constructor: ->
    BookingV2.Views.Base.apply this, arguments

    @collection.on 'clear', @clearSelection, this
    @collection.on 'request', @clearSelection, this
    @model.on "change:#{@options.selected}", (model, selection) =>
      @content().options.selected = selection
      @render()

  show: ->
    @redraw()
    @trigger 'expand', this

    transitionEndHandler = => @trigger 'expanded', this
    setTimeout(transitionEndHandler, @transitionDuration)
    @$el.removeClass(@collapsedClassName).addClass(@expandedClassName)

  hide: ->
    @redraw()
    @trigger 'collapse', this

    transitionEndHandler = =>
      @trigger 'collapsed', this
      @$el.addClass(@collapsedClassName)

    setTimeout(transitionEndHandler, @transitionDuration)
    @$el.removeClass(@expandedClassName)

  toggle: ->
    if @isVisible()
      @hide()
    else
      @show()
